import 'bootstrap/dist/js/bootstrap.bundle.js'

import 'unpoly/unpoly.js'
import 'unpoly/unpoly.css'
import 'unpoly/unpoly-bootstrap5.js'
import 'unpoly/unpoly-bootstrap5.css'

import './application/bootstrap.sass'
import './application/theme.sass'
import './application/unpoly_config.js'
import './application/audio_recorder.js'
import './application/narration_recorder.js'
